export const getMethodApprovedFromSearch = (
    search = window.location.search,
): 'email' | 'sms' | 'fac_email' | undefined => {
  const deliveryMethod = new URLSearchParams(search).get('deliveryMethod');
  return deliveryMethod === 'email' ||
      deliveryMethod === 'sms' ||
      deliveryMethod === 'fac_email' ?
      deliveryMethod :
      undefined;
};
